import React from 'react';

const UpgradeModal = ({ isOpen, reason, logoUrl, onUpgrade, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#343541] rounded-lg p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-[#f5f5f0] rounded-full flex items-center justify-center mx-auto mb-4">
            <img src={logoUrl} alt="Ladder" className="w-12 h-12 rounded-full object-cover" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Upgrade to Pro</h2>
          <p className="text-gray-300 text-sm mb-4">{reason}</p>
        </div>
        <div className="space-y-4 mb-6">
          <div className="bg-[#23242a] rounded-lg p-4">
            <h3 className="text-lg font-semibold text-white mb-3">Pro Features:</h3>
            <ul className="text-gray-300 text-sm space-y-2">
              {['Unlimited searches', 'Unlimited email lookups', 'Unlimited email drafts', 'Unlimited emails sent', 'Priority support'].map(
                feature => (
                  <li key={feature} className="flex items-center">
                    <svg className="w-4 h-4 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {feature}
                  </li>
                ),
              )}
            </ul>
          </div>
        </div>
        <div className="space-y-3">
          <button
            onClick={onUpgrade}
            className="w-full bg-[#f5f5f0] text-gray-800 py-3 px-4 rounded-lg hover:bg-[#e8e8e0] transition-colors font-semibold"
          >
            Upgrade to Pro - $9.99/month
          </button>
          <button
            onClick={onClose}
            className="w-full bg-transparent text-gray-400 py-2 px-4 rounded-lg hover:bg-[#23242a] transition-colors"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export { UpgradeModal };
